module.exports = __webpack_public_path__ + "static/media/generated.235f42c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/generated.svg
// module id = 530
// module chunks = 1